<template>
  <layout-base>
    <hero />

    <highlight />

    <strength />

    <pricing />

    <feature />

    <portfolio />

    <call-to-action />
  </layout-base>
</template>

<script>
import LayoutBase from '@/Layouts/Base.vue';

import CallToAction from '@/Pages/Index/Sections/CallToAction.vue';
import Feature from '@/Pages/Index/Sections/Feature.vue';
import Hero from '@/Pages/Index/Sections/Hero.vue';
import Highlight from '@/Pages/Index/Sections/Highlight.vue';
import Portfolio from '@/Pages/Index/Sections/Portfolio.vue';
import Pricing from '@/Pages/Index/Sections/Pricing.vue';
import Strength from '@/Pages/Index/Sections/Strength.vue';

import { faAward, faCheck, faClock, faCloudUploadAlt, faEnvelope, faFileAlt, faHdd, faLifeRing, faMapSigns, faPaperPlane, faPiggyBank, faQuoteRight, faServer, faSync, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faMonitorHeartRate } from '@fortawesome/pro-solid-svg-icons';
import { faArrowRight, faLanguage, faStopwatch } from '@fortawesome/pro-regular-svg-icons';
import { faFacebookF, faInstagram, faLinkedinIn, faTwitter, faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { library as FontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core';

FontAwesomeLibrary.add(faArrowRight, faAward, faCheck, faClock, faCloudUploadAlt, faEnvelope, faFacebookF, faFileAlt, faHdd, faInstagram, faLanguage, faLifeRing, faLinkedinIn, faMapSigns, faMonitorHeartRate, faPaperPlane, faPiggyBank, faQuoteRight, faServer, faSpinnerThird, faStopwatch, faSync, faTimes, faTwitter, faWhatsapp, faYoutube);

export default {
  components: {
    LayoutBase,
    CallToAction,
    Feature,
    Hero,
    Highlight,
    Portfolio,
    Pricing,
    Strength
  }
};
</script>
